import axios from "axios";

// The MCP server identifies the user by forwarding the session cookie to Flask,
// so requests must be sent with credentials.
const mcpInstance = axios.create({
  baseURL: import.meta.env.VITE_MCP_AUTH_URL,
  timeout: Number(import.meta.env.VITE_AXIOS_TIMEOUT),
  withCredentials: true,
});

export default mcpInstance;
